"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adminAdd = adminAdd;
exports.adminDel = adminDel;
exports.adminInfo = adminInfo;
exports.adminList = adminList;
exports.adminUpdate = adminUpdate;
exports.adminUpdatePwd = adminUpdatePwd;
exports.getMenu = getMenu;
exports.menuAdd = menuAdd;
exports.menuDelete = menuDelete;
exports.menuInfo = menuInfo;
exports.menuListApi = menuListApi;
exports.menuUpdate = menuUpdate;
exports.menuUpdateShowStatus = menuUpdateShowStatus;
exports.sensitiveListApi = sensitiveListApi;
exports.updateIsSmsApi = updateIsSmsApi;
exports.updateStatusApi = updateStatusApi;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

function getMenu() {
  return (0, _request.default)({
    url: '/admin/system/role/testMenu',
    method: 'GET'
  });
}
function adminDel(pram) {
  var data = {
    id: pram.id
  };
  return (0, _requestMapi.default)({
    url: '/mapi/system/admin/delete',
    method: 'GET',
    params: data
  });
}
function adminInfo(pram) {
  var data = {
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/system/admin/info',
    method: 'GET',
    params: data
  });
}
function adminList(params) {
  return (0, _requestMapi.default)({
    url: '/mapi/system/admin/list',
    method: 'GET',
    params: params
  });
}
function adminAdd(pram) {
  var data = {
    account: pram.account,
    level: pram.level,
    pwd: pram.pwd,
    realName: pram.realName,
    roles: pram.roles.join(','),
    status: pram.status,
    type: pram.type,
    phone: pram.phone,
    email: pram.email,
    larkOpenId: pram.larkOpenId
  };
  return (0, _requestMapi.default)({
    url: '/mapi/system/admin/save',
    method: 'POST',
    data: data
  });
}
function adminUpdate(pram) {
  var data = {
    account: pram.account,
    phone: pram.phone,
    pwd: pram.pwd,
    roles: pram.roles,
    realName: pram.realName,
    status: pram.status,
    type: pram.type,
    id: pram.id,
    isDel: pram.isDel,
    email: pram.email,
    larkOpenId: pram.larkOpenId
  };
  return (0, _requestMapi.default)({
    url: '/mapi/system/admin/update',
    method: 'POST',
    data: data
  });
}
function adminUpdatePwd(pram) {
  var data = {
    account: pram.account,
    pwd: pram.pwd,
    realName: pram.realName,
    id: pram.id,
    isDel: pram.isDel
  };
  return (0, _request.default)({
    url: '/admin/system/admin/updatePassword',
    method: 'POST',
    data: data
  });
}

/**
 * 修改状态
 * @param pram
 */
function updateStatusApi(params) {
  return (0, _request.default)({
    url: "/admin/system/admin/updateStatus",
    method: 'get',
    params: params
  });
}

/**
 * 修改后台管理员是否接收状态
 * @param pram
 */
function updateIsSmsApi(params) {
  return (0, _request.default)({
    url: "/admin/system/admin/update/isSms",
    method: 'get',
    params: params
  });
}

/**
 * 权限规则菜单列表
 * @param params
 */
function menuListApi(params) {
  return (0, _requestMapi.default)({
    url: "/mapi/system/admin/menu/list",
    method: 'get',
    params: params
  });
}

/**
 * 权限规则新增菜单
 * @param data
 */
function menuAdd(data) {
  return (0, _requestMapi.default)({
    url: "/mapi/system/admin/menu/add",
    method: 'post',
    data: data
  });
}

/**
 * 权限规则删除菜单
 * @param id
 */
function menuDelete(id) {
  return (0, _requestMapi.default)({
    url: "/mapi/system/admin/menu/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 权限规则菜单详情
 * @param id
 */
function menuInfo(id) {
  return (0, _requestMapi.default)({
    url: "/mapi/system/admin/menu/info/".concat(id),
    method: 'get'
  });
}

/**
 * 权限规则菜单修改
 * @param data
 */
function menuUpdate(data) {
  return (0, _requestMapi.default)({
    url: "/mapi/system/admin/menu/update",
    method: 'post',
    data: data
  });
}

/**
 * 权限规则修改菜单显示状态
 * @param params
 */
function menuUpdateShowStatus(params) {
  return (0, _requestMapi.default)({
    url: "/mapi/system/admin/menu/updateShowStatus/".concat(params.id),
    method: 'post'
  });
}

//
/**
 * 权限规则菜单详情
 * @param data
 */
function sensitiveListApi(params) {
  return (0, _request.default)({
    url: "/admin/log/sensitive/list",
    method: 'get',
    params: params
  });
}